import * as qs from 'querystring';
import { useCallback, useMemo } from 'react';
import { MBLinking } from '@shared/util/linking';

export function useOpenMap(lat: number, lon: number) {
  return useCallback(() => {
    const link = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
    MBLinking.open(link);
  }, [lat, lon]);
}

export function useGoogleMapsImageUrl({
  lat,
  lon,
  iconUrl = 'https://assets.coastapp.com/geolocation-pin.png',
  size = '480x240',
  zoom = 15,
  scale = 2,
}: {
  lat: number;
  lon: number;
  iconUrl?: string;
  size?: string;
  zoom?: number;
  scale?: number;
}): string | undefined {
  return useMemo(() => {
    return `https://maps.googleapis.com/maps/api/staticmap?${qs.stringify({
      zoom,
      size,
      scale,
      maptype: 'roadmap',
      format: 'jpg',
      markers: [`icon:${iconUrl}`, `${lat},${lon}`].join('|'),
      key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    })}`;
  }, [lat, lon, size, zoom, scale, iconUrl]);
}

export function useFetchCurrentGeolocation(): () => Promise<GeolocationCoordinates> {
  return useCallback(async () => {
    return new Promise<GeolocationCoordinates>(async (resolve, reject) => {
      navigator.geolocation.getCurrentPosition(res => resolve(res.coords), reject, {
        timeout: 5000,
        maximumAge: 0,
      });
    });
  }, []);
}
